import { PropsWithChildren } from 'react';
import Loading from '../components/Loading';
import { Algorithm } from '../config/config';
import { useConfig } from '../hooks/other/useConfig';
import { DappAuthManager } from './DappAuthManager';
import { DevAuthManager } from './DevAuthManager';
import { useIdpInfo } from './IdpContext';
import { OidcAuthManager } from './OidcAuthManager';

export const AuthFactory: React.FC<PropsWithChildren> = ({ children }) => {
  const { enableDappLogin } = useConfig().app;
  const { idpInfo, isLoading } = useIdpInfo();
  // 1. Wait for config
  if (isLoading || (!idpInfo && !enableDappLogin)) {
    return <Loading />;
  }

  // 2. Dapp Strategy
  if (enableDappLogin) {
    return <DappAuthManager>{children}</DappAuthManager>;
  }

  // 3. OIDC Strategy
  if (idpInfo?.algorithm === Algorithm.RS256) {
    return <OidcAuthManager>{children}</OidcAuthManager>;
  }

  // 4. Dev/Unsafe Strategy

  if (idpInfo?.algorithm === Algorithm.HS256UNSAFE) {
    return <DevAuthManager>{children}</DevAuthManager>;
  }
  if (idpInfo?.algorithm === 'idp-not-set') {
    return <Loading text="Logging out..." />;
  }

  return <Loading />;
};
